<template>
    <div>
        <form class="tw-mt-10 xs:tw-mt-5">
            <div class="row align-items-center">
                <div class="col-xl-8 col-lg-8 col-md-8 col-12">
                    <div
                        v-if="loading"
                        class="tw-w-full tw-h-[302px] tw-flex tw-items-center tw-justify-center"
                    >
                        <clip-loader
                            :loading="true"
                            color="blue"
                            size="30px"
                        ></clip-loader>
                    </div>
                    <div
                        v-else-if="
                            generalStore.get_active_login_form == 'chat_login'
                        "
                        class="tw-tw-w-full"
                    >
                        <ChatLoginInputs
                            v-if="
                                generalStore.get_active_login_form ==
                                'chat_login'
                            "
                        ></ChatLoginInputs>

                        <van-divider>or</van-divider>

                        <ContinueWithGoogleButton />

                        <div class="tw-text-center tw-my-3">
                            <span
                                data-bs-toggle="modal"
                                data-bs-target="#registerFormModal"
                                class="tw-cursor-pointer tw-text-md tw-font-bold hover:tw-underline tw-text-main-color"
                                >{{ __("chat.create_new_account") }}</span
                            >
                        </div>
                    </div>
                    <div
                        v-else-if="
                            generalStore.get_active_login_form == 're_verify'
                        "
                    >
                        <VerifyInputs></VerifyInputs>
                    </div>
                    <div
                        v-else-if="
                            generalStore.get_active_login_form == 're_activate'
                        "
                    >
                        <ReActivateInputs></ReActivateInputs>
                    </div>

                    <div class="tw-w-full tw-text-center">
                        <a
                            href="https://apps.apple.com/ca/app/titi-chat/id6461728173"
                            target="_blank"
                        >
                            <img
                                :src="
                                    require('@asset/landing/img/apple_app_store.png')
                                "
                                class="tw-h-10"
                                alt=""
                            />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.titi.chat&pcampaignid=web_share"
                            target="_blank"
                        >
                            <img
                                :src="
                                    require('@asset/landing/img/google_app_store.png')
                                "
                                class="tw-h-10"
                                alt=""
                            />
                        </a>
                    </div>
                </div>
            </div>
        </form>
        <RegisterForm></RegisterForm>
        <ForgotPassword></ForgotPassword>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import ChatLoginInputs from "@landing/Components/ChatLoginInputs.vue";
import RegisterForm from "@landing/Components/RegisterForm.vue";
import { generalStore } from "@landing/Stores/general_store";
import VerifyInputs from "@landing/Components/VerifyInputs.vue";
import ForgotPassword from "@landing/Components/ForgotPassword.vue";
import ReActivateInputs from "@landing/Components/ReActivateInputs.vue";
import ContinueWithGoogleButton from "@landing/Components/ContinueWithGoogleButton.vue";

export default {
    components: {
        ClipLoader,
        ChatLoginInputs,
        RegisterForm,
        VerifyInputs,
        ForgotPassword,
        ReActivateInputs,
        ContinueWithGoogleButton,
    },
    data() {
        return {
            loading: true,
            generalStore: generalStore(),
        };
    },
    mounted() {
        setTimeout(() => {
            this.loading = false;
        }, 500);
    },
    methods: {},
    computed: {
        activeLoginForm() {
            return this.generalStore.get_active_login_form;
        },
    },
    watch: {
        activeLoginForm() {
            this.loading = true;

            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
    },
};
</script>
